<template>
  <v-menu
    bottom left
    v-if="isAuthenticatedRoute"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        text
        v-on="on"
      >
        <div class="text-capitalize title-style">{{ currentUserDisplayName }}</div>
        <v-icon class="ml-3" large>account_circle</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="handleMyProfileClick">
        <v-list-item-title>
          <v-icon class="mr-3">account_box</v-icon>
          My Profile
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="handleLogoutClick">
        <v-list-item-title>
          <v-icon class="mr-3">exit_to_app</v-icon>
          Log out
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: [
    'currentUserDisplayName',
    'isAuthenticatedRoute'
  ],
  methods: {
    handleMyProfileClick () {
      this.$emit('my-profile-clicked')
    },
    handleLogoutClick () {
      this.$emit('logout-clicked')
    }
  }
}
</script>

<style>

</style>
